import React from 'react'
import Widget from '../../elements/Widget'

const Index = () => (
  <div className="row">
    <div className="col">
      <Widget title="" description="Welcome to the Project Management App. How do we get started?" />
    </div>
  </div>
)
export default Index



// WEBPACK FOOTER //
// ./src/pages/empty-page/index.js